"use client";
import React from "react";
import Counter from "./Counter";
import Button from "../../../ui/Button";
import { Header } from "../../../ui/Headers";
import { Bg2 } from "src/app/components/Icon";
import { CompanyName } from "./TrustedPartner";

const Automate = () => {
  return (
    <section className="py-14 relative overflow-hidden bg-[linear-gradient(90deg,rgba(var(--primary-color-rgb),0.95)_0%,rgba(var(--primary-color-rgb),0.90)_100%),url('/images/bg-image-3.webp')] bg-cover bg-center">
      <Bg2 />
      <div className="wrapper md:flex-col-reverse md:gap-10 flex">
        <div className="first relative z-[5] basis-1/2 flex flex-col gap-5">
          <Header className="font-semibold text-white !text-left">
            Looking To Buy Or Sell? <br /> Get Expert Guidance Today!
          </Header>
          <h3 className="text-white h5 mb-5 max-w-[600px]">
            Looking for expert property management, quick property sales,
            rentals, or short-let options? At {<CompanyName />}, we are your
            ultimate destination for diverse real estate solutions.
          </h3>
          <Button
            href="/contact"
            variant="secondary"
            className="!w-max !py-3 !px-8"
          >
            Contact Us
          </Button>
        </div>

        <div className="second relative z-[5] basis-1/2 grid place-items-center">
          <Counter />
        </div>
      </div>
    </section>
  );
};
export default Automate;
